import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";

const collectEmails = (emails) => {
  const seen = new Set();
  const list = [];
  (emails || []).forEach((email) => {
    const value = typeof email === "string" ? email.trim() : "";
    if (!value) return;
    const key = value.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    list.push(value);
  });
  return list;
};

const copyText = (text, onSuccess) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard
      .writeText(text)
      .then(onSuccess)
      .catch(() => fallbackCopy(text, onSuccess));
    return;
  }
  fallbackCopy(text, onSuccess);
};

const fallbackCopy = (text, onSuccess) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.position = "fixed";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  try {
    if (document.execCommand("copy")) onSuccess();
  } catch (err) {
    console.error("Fallback: unable to copy", err);
  }
  document.body.removeChild(textArea);
};

const CopyEmailsButton = ({ emails = [] }) => {
  const [copied, setCopied] = useState(false);
  const list = collectEmails(emails);
  if (!list.length) return null;

  const label = list.length > 1 ? "Copy emails" : "Copy email";

  const onSuccess = () => {
    setCopied(true);
    toast.success("Copied to clipboard!", {
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
    });
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopy = (event) => {
    event.preventDefault();
    event.stopPropagation();
    copyText(list.join(", "), onSuccess);
  };

  return (
    <OverlayTrigger
      placement="bottom"
      delay={{ show: 250, hide: 400 }}
      overlay={<Tooltip id="copy-emails-tooltip">{label}</Tooltip>}
    >
      <button
        type="button"
        className="font-size"
        onClick={handleCopy}
        aria-label={label}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          lineHeight: 1,
        }}
      >
        <i
          className={`mdi ${
            copied ? "mdi-check text-success" : "mdi-email-outline"
          } font-size`}
          style={{ cursor: "pointer", fontSize: "18px" }}
        />
      </button>
    </OverlayTrigger>
  );
};

export default CopyEmailsButton;
